module.exports = {
	"pagination": {
		"ListResourcesForTagOption": {
			"input_token": "PageToken",
			"output_token": "PageToken",
			"limit_key": "PageSize"
		},
		"ListTagOptions": {
			"input_token": "PageToken",
			"output_token": "PageToken",
			"limit_key": "PageSize"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/servicecatalog-2015-12-10.paginators.json
// module id = 1404
// module chunks = 0